export function generateReference(): string {
  const year = new Date().getFullYear();
  const rand = Math.floor(1000 + Math.random() * 9000);
  return `BF-CAP-${year}-${rand}`;
}

export function formatShortDate(d: Date | null | undefined): string {
  if (!d) return '\u2014';
  return d.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' });
}

/** Two decimals, thousands separators — for rate-card figures (price per ton, price per unit). */
export function formatCurrency(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '\u2014';
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 });
}

/** Whole dollars, thousands separators — for summary/estimate figures (never quoted as a rate). */
export function formatCurrencyWhole(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '\u2014';
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
}

export function commitmentMonths(commitment: string | null): number {
  switch (commitment) {
    case '12 months':
      return 12;
    case '24 months':
      return 24;
    case '36 months':
      return 36;
    case '48 months':
      return 48;
    case '6 months':
      return 6;
    case 'Month-to-Month':
      return 1;
    default:
      return 1;
  }
}
